import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Vi fandt ")
const _hoisted_2 = { class: "text-primary" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_application_modal = _resolveComponent("application-modal")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_application_modal, { ref: "applicationModal" }, null, 512),
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeader, {
          searchPlaceholder: "Søg efter applikationer her...",
          canSearch: true,
          searchEntry: _ctx.filters.global.value,
          "onUpdate:searchEntry": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.global.value = $event)),
          actionButtonTitle: _ctx.canCreateApp ? 'Opret applikation' : undefined,
          onOnActionButton: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applicationModal?.show(null))),
          title: "Applikationer"
        }, {
          subtitle: _withCtx(() => [
            _createVNode("strong", null, [
              _hoisted_1,
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.filteredCount), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.usePluralFilter(_ctx.filteredCount, "applikation", "applikationer")), 1)
            ])
          ]),
          _: 1
        }, 8, ["searchEntry", "actionButtonTitle"]),
        _createVNode(_component_DataTable, {
          sortField: "name",
          sortOrder: 1,
          selectionMode: "single",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: ['name', 'applicationId'],
          onRowSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onRowClick($event.data))),
          onFilter: _ctx.onFilter,
          value: _ctx.applications
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_error, { error: {
            title: 'Ingen applikationer',
            message:
              'Der er ikke nogle applikationer oprettet i brugerkataloget endnu',
          } })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              columnKey: "applicationName"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("strong", null, _toDisplayString(data.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { columnKey: "details" }, {
              body: _withCtx(({ data }) => [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "me-4 text-primary",
                    icon: ['fas', 'users-cog']
                  }),
                  _createTextVNode(" " + _toDisplayString(data.roles?.length) + " roller ", 1),
                  _createVNode(_component_font_awesome_icon, {
                    class: "ms-auto text-secondary",
                    icon: ['fas', 'chevron-right']
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["filters", "onFilter", "value"])
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
}